'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = require('react-bootstrap');

var _style = require('./style');

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Password = function Password(props) {
  return _react2.default.createElement(
    _reactBootstrap.Grid,
    null,
    _react2.default.createElement(
      _reactBootstrap.Row,
      null,
      _react2.default.createElement(
        _reactBootstrap.Col,
        { mdOffset: 4, md: 4 },
        _react2.default.createElement(
          'form',
          null,
          _react2.default.createElement(
            _reactBootstrap.FormGroup,
            {
              bsSize: 'large',
              className: _style2.default.container
            },
            _react2.default.createElement(_reactBootstrap.FormControl, {
              type: 'password',
              placeholder: '\u820A\u5BC6\u78BC',
              value: props.oldPassword,
              onChange: function onChange(event) {
                return props.setOldPassword(event.target.value);
              }
            }),
            _react2.default.createElement(_reactBootstrap.FormControl, {
              type: 'password',
              placeholder: '\u65B0\u5BC6\u78BC',
              value: props.newPassword,
              onChange: function onChange(event) {
                return props.setNewPassword(event.target.value);
              }
            }),
            _react2.default.createElement(_reactBootstrap.FormControl, {
              type: 'password',
              placeholder: '\u8ACB\u78BA\u8A8D\u65B0\u5BC6\u78BC',
              value: props.confirmPassword,
              onChange: function onChange(event) {
                return props.setConfirmPassword(event.target.value);
              },
              onKeyUp: function onKeyUp(event) {
                return event.keyCode === 13 ? props.changePassword() : null;
              }
            })
          ),
          _react2.default.createElement(
            _reactBootstrap.FormGroup,
            null,
            _react2.default.createElement(
              _reactBootstrap.Button,
              {
                bsStyle: 'primary',
                block: true, type: 'button',
                onClick: props.changePassword
              },
              '\u9001\u51FA'
            )
          )
        ),
        props.message ? _react2.default.createElement(
          _reactBootstrap.Alert,
          { bsStyle: props.messageStyle },
          props.message
        ) : null
      )
    )
  );
};

var string = _propTypes2.default.string,
    func = _propTypes2.default.func;

Password.propTypes = {
  oldPassword: string,
  newPassword: string,
  confirmPassword: string,
  setOldPassword: func,
  setNewPassword: func,
  setConfirmPassword: func,
  changePassword: func,
  message: string,
  messageStyle: string
};

exports.default = Password;


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/Password/Password.js
// module id = 1314
// module chunks = 0